import { faPencil, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from "semantic-ui-react";

import { DESK_COMMUNICATION_EVENTS } from "models";

import type { DeskCommunication, DeskCommunicationEvent } from "models";

type EventInfoProps = {
  event: DeskCommunicationEvent;
  comm: DeskCommunication;
};

export const EventInfo = ({ event, comm }: EventInfoProps) => {
  const fullname = event.type === DESK_COMMUNICATION_EVENTS.DeskCheckInSent && comm.user && `${comm.user.first_name} ${comm.user.last_name}`;

  return (
    <Grid.Row width={16} className="event-info-rows">
      {fullname && (
        <span>
          <FontAwesomeIcon icon={faUser} className="i-green mr-5" />
          {fullname}
        </span>
      )}

      {event.customer_name && (
        <span>
          <FontAwesomeIcon icon={faPencil} className="i-green mr-5" />
          {event.customer_name}
        </span>
      )}
    </Grid.Row>
  );
};
